import Axios from 'axios'
import { BACKEND_URL } from '../constants'

const axios = Axios.create({
  baseURL: BACKEND_URL,
})

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.set('Authorization', 'Bearer ' + token);
  return config;
});
export default axios
